// extracted by mini-css-extract-plugin
export default {"header":"header_header__7p0kh","mobile":"header_mobile__nV-2h","day":"header_day__Ij-PM"};